import { parsePhoneNumberFromString } from 'libphonenumber-js';

export const required = (value: string) =>
  value || parseInt(value, 10) === 0 ? undefined : 'Required';

export const validEmail = (value: string) =>
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    value,
  )
    ? undefined
    : 'Must be a valid email address';

export const validTelephone = (value: string) =>
  parsePhoneNumberFromString(value, 'US')?.isValid()
    ? undefined
    : 'Must be a valid US telephone number';
